// Timesheets on Home (round 44): the three numbers the office acts on, each a
// link to the board already filtered. Drawn only when the server sends the
// block, which it does only for a company with timesheets switched on.
import { Link } from 'react-router-dom';
import type { HomeData } from '../homeApi';

export function HomeTimesheets({ timesheets }: { timesheets: NonNullable<HomeData['timesheets']> }) {
  const cards = [
    {
      label: 'Waiting for approval',
      value: timesheets.awaitingApproval,
      sub: 'submitted, any week',
      to: '/app/timesheets?status=submitted',
    },
    {
      label: 'Not in for last week',
      value: timesheets.notHandedInLastWeek,
      sub: 'missing, draft or sent back',
      // The whole week, not the Missing chip: this count includes drafts and
      // sent-back weeks too, which the board sorts to the top by status.
      to: `/app/timesheets?week=${timesheets.lastWeekStart}`,
    },
    {
      label: 'Sent back',
      value: timesheets.returned,
      sub: 'waiting on the worker',
      to: '/app/timesheets?status=returned',
    },
  ];

  return (
    <section className="panel">
      <div className="row mb-5">
        <h1 className="!mb-0">Timesheets</h1>
        <span className="spacer" />
        <Link to="/app/timesheets/export" className="btn-secondary btn-sm">
          Export CSV
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {cards.map((card) => (
          <Link
            key={card.label}
            to={card.to}
            className="block min-h-11 rounded-lg border border-gray-200 p-4 hover:border-gray-300 hover:bg-gray-50"
          >
            <div className="text-sm text-gray-600">{card.label}</div>
            <div className="text-2xl font-semibold tabular-nums text-gray-900">{card.value}</div>
            <div className="text-sm text-gray-600">{card.sub}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
